import { Component, Input, DoCheck, ViewChild,Inject, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FilterOptionService } from '../filter-selection/services/filter-option.service';
import {
  DivDataView,
  FilterOption,
  DistributorFilterModel,
  ContractFilterOptionsModel,
  QSRFilterOptionsModel,
  SelectedFilterOption,
  PestFilterModel,
  FRSFilterOptionsModel,
} from 'src/app/global/filter-options-types';
import { forEach } from 'lodash';
import { FilterRequests } from 'src/app/core/services/filter-requests.service';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Router } from '@angular/router';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { ServiceInsightsService } from '../service-insights/services/service-insights-service.service';
import { SolutionParticipationService } from '../solution-participation-details/service/solution-participation.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { AccountSpecificFilterComponent } from './components/account-specific-filter/account-specific-filter.component';
import { TVDService } from 'src/app/features/total-value-delivery/services/tvd.service';
import { TVDDistributorService } from '../total-value-delivery/services/tvd-distributor.service';
import { ActionCenterService } from '../action-center/service/action-center.service';
import { CountriesService } from 'src/app/core/services/countries.service';
import { FormControl } from '@angular/forms';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { TvdCostAssumptionsService } from '../total-value-delivery/services/tvd-cost-assumptions.service';
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';
import { Subscription } from 'rxjs';
import { Division, Region } from 'src/app/core/services/ebr-api-client/ebr-api-client.g';
import { ServiceInsightsDetailsStore } from '../service-insights/stores/service-insights-details.store';


@Component({
    selector: 'app-generic-filter',
    templateUrl: './generic-filter-panel.component.html',
    styleUrls: ['./generic-filter-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [],
    standalone: false
})
export class GenericFilterComponent implements DoCheck {
  hideApplyButton: boolean = true;
  @Output() hideProceedWithSelectionButton = new EventEmitter<boolean>();

  @Input() filterOptions: FilterOption[] = [];
  @Input() acctNumLevel: number = -1;

  selectedTopLevelContractGroup: string = '';
  selectedSecondLevelContractFilter: string[] = [];
  selectedThirdLevelContractFilter: string[] = [];
  FourthLevelContractFilter: string[] = [];
  firstLevelFiltersSelected: boolean = false; // Controls display of next level filters in Neptune UI
  accts: string[] = [];

  // save filter or recall variables
  filterSaveNameVisible: boolean = false;
  namePanelCoverVisible: boolean = false;
  loaderVisible: boolean = true; //big loader symbol
  filterRecallVisible: boolean = false;
  saveSelectionsLevel = 3;
  isSaveSelectionLinkVisible: boolean = false;

  selectedDivisionDataView: DivDataView | undefined;
  filters: ContractModel | undefined;
  filterSubscription: Subscription | undefined;

  divDataView: string = '';
  applyButton: boolean = true;
  isApplyButtonEnabled:boolean = true;

  // account
  @ViewChild('accountTextArea')
  accountTextArea!: AccountSpecificFilterComponent;
  isAcctNumberVisible: boolean = false;

  minimumDate: Date = new Date();
  maximumDate: Date = new Date();
  // Form Controls connected to the calendar input
  startDate = new FormControl(_moment.default());
  endDate = new FormControl(_moment.default());
  customDateRange: string = '';

  showCustomDatePickers : boolean = false;

  excludeDeletedAccounts: boolean = false;
  excludeDeletedAccountsSubscription: Subscription | undefined;
  hideExcludeDeletedAccountsCheckbox: boolean = false;

  oneCustomerName: string | undefined;
  oneCustomerNameSubscription: Subscription | undefined;

  constructor(
    private filterOptionService: FilterOptionService,
    private filterService: FiltersService,
    private filterRequests: FilterRequests,
    private router: Router,
    private mixpanelService: MixpanelService,
    private serviceInsightsService: ServiceInsightsService,
    private solParticipationService: SolutionParticipationService,
    private tvdService: TVDService,
    private tvdDistService: TVDDistributorService,
    private _actionCenterService: ActionCenterService, //this is for action center,
    private _countriesService: CountriesService,
    @Inject(FEATURE_FLAGS) private featureFlags: FeatureFlags,
    private _tvdCostAssumptionsService: TvdCostAssumptionsService,
    private _siDetailsStore: ServiceInsightsDetailsStore,
  ) {
    this.filterOptionService.selectedDivisionDataView.subscribe((data) => {
      this.selectedDivisionDataView = data;
    });
    this.filterService.customDateRangeObservable.subscribe((data) => {
      if (data.startDate.moment && data.endDate.moment) {
        this.startDate.setValue(data.startDate.moment);
        this.endDate.setValue(data.endDate.moment);
      }
    });
    this.filterSubscription = this.filterService.selectedFiltersObservable.subscribe(f => this.filters = f);
    this.oneCustomerNameSubscription = this.filterService.oneCustomerNameObservable.subscribe(name => this.oneCustomerName = name);
    this.excludeDeletedAccountsSubscription = this.filterRequests.excludeDeletedAccountsObservable.subscribe(f => this.excludeDeletedAccounts = f);
  }

  async ngOnInit() {
    if(this.filters && this.filters.countries && this.filters.countries.length > 0){
      this.firstLevelFiltersSelected = true;
    }

    // Set initial value for exclude deleted accounts
    this.hideExcludeDeletedAccountsCheckbox = this.selectedDivisionDataView?.division === Division.Pest || this.selectedDivisionDataView?.division === Division.Distributor || this.oneCustomerName != '';
    this.setInitialExcludeDeletedAccountsValue();

    if (this.selectedDivisionDataView != undefined) {
      this.divDataView =
        this.selectedDivisionDataView.dataView ||
        this.selectedDivisionDataView.division;
    }

    if (this.divDataView == 'Distributor') {
      this.saveSelectionsLevel = 1;
      this.showDataLoader(DistributorFilterModel.TopLevelContractGroup);
      this.showDataLoader(DistributorFilterModel.SecondLevelContractFilter);
      try {
        // Get both top and second level filters
        const [topLevelOptions, secondLevelOptions] = await Promise.all([
          this.filterOptionService.updateOptionsForDistributor(
            DistributorFilterModel.TopLevelContractGroup,
            'Distributor',
            this.filterOptions
          ),
          this.filterOptionService.updateOptionsForDistributor(
            DistributorFilterModel.SecondLevelContractFilter,
            'Distributor',
            this.filterOptions
          ),
        ]);

        // Update the filter options with the fetched data
        this.filterOptions[
          DistributorFilterModel.TopLevelContractGroup
        ].optionList = topLevelOptions;
        this.filterOptions[
          DistributorFilterModel.SecondLevelContractFilter
        ].optionList = secondLevelOptions;
      } catch (error) {
        throw new Error('Unable to fetch Distributor hierarchy');
      } finally {
        // Hide loaders for both levels
        this.hideDataLoader(DistributorFilterModel.TopLevelContractGroup);
        this.hideDataLoader(DistributorFilterModel.SecondLevelContractFilter);
      }
    }

    this.minimumDate = this.filterService.getMinimumDate();
    this.maximumDate = this.filterService.getMaximumDate();
    await this.updateAccountNumVisibilityAndValues();
  }

  private async updateAccountNumVisibilityAndValues() {
    const selectedAccountNos = this.filterService.getSelectedAccountNos();

    // if the filter option has selected values and that the the level is 1 less than the account level then account box should be visible
    for (let i = 0; i < this.filterOptions.length; i++) {
      if (
        this.filterOptions[i].selected.length > 0 &&
        this.filterOptions[i].level == this.acctNumLevel - 1
      ) {
        this.isAcctNumberVisible = true;
        break;
      }
    }
    if (selectedAccountNos.length > 0) {
      await this.onAccountNumberTyping(selectedAccountNos?.join(','));
      this.accountTextArea.value = selectedAccountNos?.join(',');
    }
  }

  ngDoCheck() {
    // Check if apply button should be visible
    let requiredOptions: FilterOption[] = this.filterOptions.filter(
      (i: FilterOption) => i.required == true
    );

    if (
      requiredOptions.every((i: FilterOption) => i.selected.toString() != '')
    ) {
      this.hideApplyButton = false;
    } else {
      this.hideApplyButton = true;

      //applying all filters and hitting the apply button,
      //it will redirect to a specific page. However, if CAM returns
      //to the filters page and manually removes the account number from the account field,
      //the apply button should then be hidden.
      if (!this.applyButton)
        this.hideApplyButton = true;
    }
    // Emit button status to filter page
    setTimeout(() => {
      // Using setTimeout to ensure that the value is emitted after the current
      // change detection cycle, allowing the UI to update accordingly.
      this.hideProceedWithSelectionButton.emit(this.hideApplyButton);
    });
  }

  //For Custom Date Ranges, as input is modified update the form values
  setMonthAndYear(selectedDate: Moment, datepicker: any, id: string) {
    if(id==='startDP'){
      // Get the value of the currently selected Moment
      const ctrlValue = this.startDate.value;
      if(ctrlValue !== null){
        // Update year and month
        ctrlValue.year(selectedDate.year());
        ctrlValue.month(selectedDate.month());
        //Set the FormControl and Observable to the month & year selected
        this.startDate.setValue(ctrlValue);
        this.filterService.setCustomDateRangeStart(ctrlValue)
      }
      else{
        console.log('The value in the Start Date FormControl is null');
      }
    }
    else if(id==='endDP'){
      // Get the value of the currently selected Moment
      const ctrlValue = this.endDate.value;
      if(ctrlValue !== null){
        // Update year and month
        ctrlValue.year(selectedDate.year());
        ctrlValue.month(selectedDate.month());
        //Set the FormControl and Observable to the month & year selected
        this.endDate.setValue(ctrlValue);
        this.filterService.setCustomDateRangeEnd(ctrlValue)
      }
      else{
        console.log('The value in the End Date FormControl is null');
      }
    }
    datepicker.close();
    this.checkValidFormVaues();
  }

  // Verify that the endDate is not before the startDate
  checkValidFormVaues(){
    if(this.startDate.value && this.endDate.value) {
      if(this.endDate.value < this.startDate.value) {
        this.isApplyButtonEnabled = false;
      }
      else{
        this.isApplyButtonEnabled = true;
      }
    }
  }

  updateSelectionHelper(event: string[], filterOption: FilterOption) {
    // We would be updating other values based on this selection
    forEach(filterOption.onChangeUpdate, async (index) => {
      this.filterOptions[index].optionList = await this.updateOptionsFor(index);

      // Updating selected values as per the changes in the optionList
      if (this.filterOptions[index].isMultiple && event.length > 0) {
        if (Array.isArray(this.filterOptions[index].selected)) {
          this.filterOptions[index].selected = this.filterOptions[
            index
          ].selected.filter((item) =>
            this.filterOptions[index].optionList.includes(item)
          );
        } else {
          // Handle the case where selected is not an array
          this.filterOptions[index].selected = [];
        }
        // Make sure subsequent levels are updated.
        if (this.filterOptions[index].selected.length > 0) {
          await this.onFilterOptionSelect(
            this.filterOptions[index].selected,
            this.filterOptions[index]
          );
        }
      } else {
        this.filterOptions[index].selected = [];
      }
    });

    const selectedRegions = this.getSelectedOptions(this.filterOptions).Regions;
    // Making the next level of options visible and resetting all levels above that
    forEach(this.filterOptions, (option) => {
      const isNextLevel = option.level == filterOption.level + 1;
      const isShownAfterId =
        option?.shownAfterId && filterOption.id === option.shownAfterId;
      const isHigherLevel = option.level > filterOption.level + 1;

      // Templates should not be available to the user if more than 1 regions are selected.
      // And also hide the template and translation
      // And also hide options when the enable tvd for AP institutional feature flag is enabled.
      const selectedRegionCodes = this.filterOptionService.mapRegionsToCodes(selectedRegions ?? []);
      if(option.id == 'templates' && (((selectedRegionCodes?.includes(Region.NA) || selectedRegionCodes?.includes(Region.AP) || selectedRegionCodes?.includes(Region.EU))
      && this.featureFlags.enableTVDForAPInstitutional)
        || (selectedRegions && selectedRegions.length > 1))) {
       option.hidden = true;
       option.selected = [];
       return;
      }

      if ((isNextLevel && !option?.shownAfterId) || isShownAfterId) {
          option.hidden = false;
      } else if (isHigherLevel && !option?.shownAfterId) {
        option.hidden = true;
        option.selected = [];
      }
    });

    // save selections visibility
    if (
      this.saveSelectionsLevel <= filterOption.level + 1 &&
      filterOption.selected.length > 0
    ) {
      this.isSaveSelectionLinkVisible = true;
    } else {
      this.isSaveSelectionLinkVisible = false;
    }

  }

  updateAccountVisibility(event: string[], filterOption: FilterOption) {
    // update account filter box visibility
    if (this.acctNumLevel > 0) {
      if (event.length > 0 && this.acctNumLevel == filterOption.level + 1) {
        this.isAcctNumberVisible = true;
      } else if (this.acctNumLevel > filterOption.level) {
        this.isAcctNumberVisible = false;
        this.accts = [];
      }
    }
  }

  async onFilterOptionSelect(event: string[], filterOption: FilterOption) {
    // Update variables for options
    if(filterOption.id === 'countries'){
      this.firstLevelFiltersSelected = event.length > 0;
    }

    // If regions are cleared we set firstLevelFiltersSelected to false
    if(filterOption.id == 'region' && event.length == 0){
      this.firstLevelFiltersSelected = false;
    }

    // If regions are updated, invalidate template and translation selections since user might
    // have come back to filter page to start a single region experience
    // where template/translations are not mandatory selections
    // if(filterOption.id == 'region' && this.filters){
    //   this.invalidatePresentationOptionsOnRegionChange();
    // }

    // If countries or regions are not selected set exclude deleted accounts value to default
    if(this.firstLevelFiltersSelected == false) {
      this.setInitialExcludeDeletedAccountsValue()
    }

    filterOption.selected = event;

    // UI : distributor has same levels partnerGroup and distributorGroup
    // Backend : distributor follows levels (Partner Group --> Distributor Group --> Account)
    var distributorSpecialCondition =
      this.divDataView == 'Distributor' &&
      (filterOption.id == 'partnerGroup' || filterOption.id == 'distributorGroup');

    if (
      (event.length == 0 && distributorSpecialCondition) ||
      (event.length == 0 && this.divDataView != 'Distributor')
    ) {
      // Everything has been deselected. Resetting filters dependent on this option
      forEach(this.filterOptions, async (option, index) => {
        const isShownAfterId =
          option?.shownAfterId && filterOption.id === option.shownAfterId;
        if (
          (option.level > filterOption.level && !option?.shownAfterId) ||
          isShownAfterId
        ) {
          option.hidden = true;
          option.selected = [];
        } else if (
          option.level == filterOption.level &&
          index > filterOption.level &&
          this.divDataView == 'Distributor'
        ) {
          // update the options for the next index if the level is same and needs an update
          this.filterOptions[index].optionList = await this.updateOptionsFor(
            index
          );
        }
      });
    } else {
      this.updateSelectionHelper(event, filterOption);
    }
    this.updateAccountVisibility(event, filterOption);

    // for some filters, event can be a string, not a string[].
    // To check for 'Custom' dateRange, first need to cast as unknown
    if(filterOption.id ==='dateRange'){
      if(event as unknown as string =='Custom'){
        this.showCustomDatePickers = true;
        this.checkValidFormVaues();
      }
      else{
        this.showCustomDatePickers = false;
        this.isApplyButtonEnabled = true;
      }
    }
  }

  async updateOptionsFor(index: number) {
    try {
      this.showDataLoader(index);
      switch (this.divDataView) {
        case 'Distributor':
          return await this.filterOptionService.updateOptionsForDistributor(
            index,
            'Distributor',
            this.filterOptions
          );
        case 'Contract':
          return await this.filterOptionService.updateOptionsForContract(
            index,
            'Contract',
            this.filterOptions
          );
        case 'QSR':
          return await this.filterOptionService.updateOptionsForFilter(
            index,
            'QSR',
            this.filterOptions,
            QSRFilterOptionsModel,
          );
        case 'Pest':
          return await this.filterOptionService.updateOptionsForFilter(
            index,
            'Pest',
            this.filterOptions,
            PestFilterModel,
          );
        case 'FRS':
          return await this.filterOptionService.updateOptionsForFilter(
            index,
            'FRS',
            this.filterOptions,
            FRSFilterOptionsModel,
          );
        default:
          if (this.filterOptions[index]?.isLoading) {
            this.filterOptions[index].isLoading = false;
          }
          return [];
      }
    } finally {
      this.hideDataLoader(index);
    }
  }

  private async confirmSelections(
    divDataView: string,
    filterOptions: any,
    accts: any
  ): Promise<void> {
    switch (divDataView) {
      case 'Distributor':
        await this.filterService.confirmSelectionsForDistributorView(
          filterOptions,
          accts
        );
        break;
      case 'Contract':
        await this.filterService.confirmSelectionsForContractView(
          filterOptions,
          accts
        );
        break;
      case 'QSR':
        await this.filterService.confirmSelectionsForQSR(filterOptions, accts);
        break;
      case 'Pest':
        await this.filterService.confirmSelectionsForPest(filterOptions, accts);
        break;
      case 'FRS':
        await this.filterService.confirmSelectionsForFRS(filterOptions, accts);
        break;
    }
  }

  async handleSaveSelectionClick(): Promise<void> {
    await this.confirmSelections(
      this.divDataView,
      this.filterOptions,
      this.accts
    );
  }

  async clickApplyButton(): Promise<void> {
    let url = '/filter';

    switch (this.divDataView) {
      case 'Distributor':
        url = '/total-value-delivery-distributor';
        break;
      case 'Contract': {
        //TODO: US622452 - Will need to remove this when we've enabled TVD for AP, LA and IMEA institutional.
        // For now, if the user selects a single region of AP or LA and the feature flag is disabled, we will redirect to solution participation details instead of TVD.
        const selectedRegions = this.filterOptions[ContractFilterOptionsModel.Regions]?.selected ?? [];
        const [singleRegion] = selectedRegions.length === 1 ? selectedRegions : [null];

        const useServiceInsights =  singleRegion === 'India, Middle East, Africa' &&   !this.featureFlags.enableTVDAndSPForIMEAInstitutional;

        const useSolParticipation =
          (singleRegion === 'Asia Pacific' && !this.featureFlags.enableTVDForAPInstitutional) ||
          (singleRegion === 'Latin America' && !this.featureFlags.enableTVDForLAInstitutional);

        url = useServiceInsights   ? '/service-insights'  : useSolParticipation ? '/solution-participation-details': '/total-value-delivery';
        break;
      }
      case 'QSR':
      case 'Pest':
        url = '/total-value-delivery';
        break;
      case 'FRS':
        //For FRS, if Europe or AP region is selected then navigate to service insights
        //else navigate to TVD.
        if((this.filterOptions[FRSFilterOptionsModel.Regions].selected.toString() === 'Europe') || (this.filterOptions[FRSFilterOptionsModel.Regions].selected.toString() === 'Asia Pacific')) {
          url = '/service-insights';
        }else{
          url = '/total-value-delivery';
        }
        break;
    }

    //If user came from One Customer application, remove their filters.
    sessionStorage.removeItem('startUpParamDestination');
    this.filterService.clearOneCustomerName();
    this.filterService.oneCustomerFilters.next(undefined);

    await this.confirmSelections(
      this.divDataView,
      this.filterOptions,
      this.accts
    );
    const dateRangeSelected = this.filterOptions.filter(_ => _.id === 'dateRange')[0]?.selected?.toString() ?? '';
    this.mixpanelService.track(`Applied Filters for ${this.divDataView}`, {
      ...this.trackFiltersOptions(),
      'Custom Date Range': this.filterService.getDateRangeForMixpanel(dateRangeSelected)
    });
    this.resetPersistedData();
    this.router.navigateByUrl(url);
  }

  /**
   * 🚨 ARCHITECTURAL MIGRATION NOTE (MODULAR STORE-DRIVEN INVALIDATION)
   *
   * Current Issue:
   * This method directly resets state across multiple unrelated services.
   * This tightly couples GenericFilterComponent to multiple feature domains
   * (TVD, Action Center, Service Insights, etc.), violating:
   *  - Single Responsibility Principle
   *  - Separation of Concerns
   *  - Modular architecture boundaries (NgModule isolation)
   *
   * 🚨 IMPORTANT:
   * These injected services exist ONLY to reset state and must be REMOVED.
   * This component should NOT:
   *   ❌ Know about feature modules
   *   ❌ Call service reset methods
   *   ❌ Orchestrate cross-domain behavior
   *
   * ------------------------------------------------------------------------------------
   * ✅ TARGET ARCHITECTURE (NgModule + STORE-BASED INVALIDATION)
   * ------------------------------------------------------------------------------------
   *
   * Each domain (TVD, Action Center, Service Insights, etc.) is already separated
   * by NgModule. This enables a clean, scalable, event-driven architecture:
   *
   *   ✔ GenericFilterModule = publishes filter changes
   *   ✔ Feature Modules     = react independently
   *
   * Instead of imperative resets, use a shared Store action to signal that:
   *
   *   👉 "Application context (filters) has changed"
   *
   * ------------------------------------------------------------------------------------
   * ✅ IMPLEMENTATION GUIDE
   * ------------------------------------------------------------------------------------
   *
   * 1. Define a shared action (in a core/shared store location):
   *
   *    export const filtersChanged = createAction(
   *      '[Filters] Changed',
   *      props<{ filters: ContractModel }>()
   *    );
   *
   * ------------------------------------------------------------------------------------
   * 2. Update this component (GenericFilterComponent):
   *
   *    Replace:
   *      this.resetPersistedData();
   *
   *    With:
   *      this.store.dispatch(filtersChanged({ filters: this.filters }));
   *
   *    ✅ After this:
   *       - DELETE resetPersistedData()
   *       - REMOVE ALL injected services used only for resetting state
   *
   * ------------------------------------------------------------------------------------
   * 3. Feature Modules handle invalidation independently
   *
   *    Each NgModule defines its own effect or reducer:
   *
   *    Example (TVD Module):
   *
   *      filtersChanged$ = createEffect(
   *        () =>
   *          this.actions$.pipe(
   *            ofType(filtersChanged),
   *            tap(() => {
   *              this.clearTvdModel();
   *              this.resetDrilldownState();
   *            })
   *          ),
   *        { dispatch: false }
   *      );
   *
   *    OR (Preferred when using store state):
   *
   *      on(filtersChanged, () => initialState)
   *
   * ------------------------------------------------------------------------------------
   * ✅ KEY DESIGN PRINCIPLES
   * ------------------------------------------------------------------------------------
   *
   * 1. Module Independence:
   *    Each feature module (NgModule) manages its own state lifecycle.
   *    No module should reset or depend on another module’s state.
   *
   * 2. Invalidation > Reset:
   *    Filters changing should signal that state is stale (invalid),
   *    not directly force a reset. Each feature decides how to respond.
   *
   * 3. No Cross-Module Coupling:
   *    This component must not import or call feature services.
   *
   * 4. Event-Driven Communication:
   *    Modules communicate via Store actions, not direct method calls.
   *
   * 5. Scoped Responsibility:
   *    - GenericFilterModule → emits filter change events
   *    - Feature Modules     → react and update their own state
   *
   * 6. Remove Central Orchestration:
   *    Avoid creating a "god effect" that resets all services.
   *    Instead, distribute logic across feature modules.
   *
   * ------------------------------------------------------------------------------------
   * ✅ MIGRATION STRATEGY
   * ------------------------------------------------------------------------------------
   *
   * Phase 1:
   *  - Introduce filtersChanged action
   *
   * Phase 2:
   *  - Implement feature-level effects/reducers in each module
   *  - Move reset logic into respective feature modules
   *
   * Phase 3:
   *  - Replace resetPersistedData() call with store.dispatch()
   *
   * Phase 4:
   *  - DELETE resetPersistedData()
   *  - REMOVE all unused injected services from constructor
   *
   * Phase 5:
   *  - Ensure each module handles only its own state (no cross-calls)
   *
   * ------------------------------------------------------------------------------------
   * ✅ FINAL MENTAL MODEL
   * ------------------------------------------------------------------------------------
   *
   *           ┌───────────────────────────┐
   *           │  GenericFilterModule      │
   *           │ (GenericFilterComponent)  │
   *           └─────────────┬─────────────┘
   *                         │
   *                         ▼
   *          dispatch(filtersChanged)
   *                         │
   *        ┌────────────────┼────────────────┐
   *        ▼                ▼                ▼
   *   TVD Module     Action Center     Service Insights
   *     (reacts)         Module              Module
   *                       (reacts)          (reacts)
   *
   *
   * ✅ Result:
   *   ✔ GenericFilterComponent is fully decoupled
   *   ✔ No awareness of downstream services
   *   ✔ Feature modules own their own state lifecycle
   *   ✔ Scalable, maintainable architecture
   *
   * ------------------------------------------------------------------------------------
   * ✅ END STATE
   * ------------------------------------------------------------------------------------
   *
   * BEFORE:
   *   GenericFilterComponent → directly resets 10+ services
   *
   * AFTER:
   *   GenericFilterModule → dispatches filtersChanged action
   *   Feature Modules     → independently react and invalidate state
   *
   * Result:
   *   ✔ Clean modular boundaries
   *   ✔ No centralized reset logic
   *   ✔ Reduced coupling
   *   ✔ Improved scalability
   *
   */
  // TODO: This needs to be refactored. It seems these servuces are injected to this component just to reset the data on apply.
  // We should move this logic to a more appropriate place and not have this component be aware of all these other services.
  //Reset any data from other sections that was persisted for the session.
  resetPersistedData() {
    this.serviceInsightsService.resetAllServices();
    this.solParticipationService.resetAllAdvancedFilters();
    this.tvdDistService.resetTVDModel();
    this.tvdService.setTVDModelToUndefined();
    this._actionCenterService.resetObservablesForActionCenter();
    this.solParticipationService.clearCache(); // Clear Solution Groups cache
    this.solParticipationService.resetWidgetData();
    this.tvdService.resetCostAssumptionsMetrics();
    this.solParticipationService.clearProductViewCache(); // Clear Product View cache
    this.solParticipationService.clearLocationViewCache(); // Clear Location View cache
    this._tvdCostAssumptionsService.resetInteractionContext();
    this.filterService.setBenchmarkOptions([]); // Clear Benchmark selection
    this._siDetailsStore.invalidateStore();
  }

  async clickClearButton() {
    this.firstLevelFiltersSelected = false;
    this.setInitialExcludeDeletedAccountsValue()
    this.filterOptions = this.filterOptionService.setFilterViewOptions(
      this.filterOptionService.setFilterOptions()
    )!;

    // if distributor then get the top level values from API
    if (this.divDataView == 'Distributor') {
      try {
        const [topLevelOptions, secondLevelOptions] = await Promise.all([
          this.filterOptionService.updateOptionsForDistributor(
            DistributorFilterModel.TopLevelContractGroup,
            'Distributor',
            this.filterOptions
          ),
          this.filterOptionService.updateOptionsForDistributor(
            DistributorFilterModel.SecondLevelContractFilter,
            'Distributor',
            this.filterOptions
          ),
        ]);
        // Update the filter options with the fetched data
        this.filterOptions[DistributorFilterModel.TopLevelContractGroup].optionList = topLevelOptions;
        this.filterOptions[DistributorFilterModel.SecondLevelContractFilter].optionList = secondLevelOptions;
      } catch (error) {
        throw new Error('Unable to fetch Distributor hierarchy');
      }
    }

    // clear account filter box on clear functionality
    if (this?.accountTextArea) {
      this.accountTextArea.value = '';
      this.accts = [];
    }

    // hiding the account field after click on clear button
    if (this.acctNumLevel > 0) this.isAcctNumberVisible = false;

    // reset the confirmed selections
    if (this.divDataView === 'Distributor') {
      await this.filterService.confirmSelectionsForDistributorView(
        this.filterOptions,
        this.accts
      );
    } else if (this.divDataView === 'Contract') {
      await this.filterService.confirmSelectionsForContractView(
        this.filterOptions,
        this.accts
      );
    } else if (this.divDataView === 'QSR') {
      await this.filterService.confirmSelectionsForQSR(
        this.filterOptions,
        this.accts
      );
    } else if(this.divDataView === 'Pest') {
      await this.filterService.confirmSelectionsForPest(
        this.filterOptions,
        this.accts
      );
    } else if (this.divDataView === 'FRS') {
      await this.filterService.confirmSelectionsForFRS(
        this.filterOptions,
        this.accts
      );
    }

    // hide save selections link
    this.isSaveSelectionLinkVisible = false;
    //hide custom date pickers
    this.showCustomDatePickers = false;
  }

  async onAccountNumberTyping(value: string) {
    if (value.length > 3) {
      this.accts = value.split(',')
          .map(account => account.trim()) // Trim each account number
          .filter(account => account !== '');
      // Display options next level above the account number level
      this.filterOptions.forEach((option) => {
        if (option.level == this.acctNumLevel + 1) {
          option.hidden = false;
        }
      });
    } else {
      // Determine if we should hide higher levels
      const shouldHideHigherLevels = this.filterOptions.some(
        (option) =>
          option.level === this.acctNumLevel && option.selected.length === 0
      );
      // If we need to hide higher levels
      if (shouldHideHigherLevels) {
        this.filterOptions.forEach((option) => {
          if (option.level > this.acctNumLevel) {
            option.hidden = true;
          }
        });
      }
      this.accts = [];
    }
  }

  private trackFiltersOptions() {
    let property: { [id: string]: string } = {};

    this.filterOptions.forEach((filterOption) => {
      let keys = filterOption.title;
      let value = filterOption.selected;

      if (value.toString() != '') {
        property[keys] = value.toString();
      }
    });
    return property;
  }

  async showFilterNamePanel() {
    await this.handleSaveSelectionClick();
    // check how many are saved
    return this.filterRequests
      .getSavedFilterSets(this.divDataView)
      .then((response) => {
        const data = response.data.savedFilters;

        // max saved filters (was 10 for testing, now higher)
        const maxSave = 100;
        if (data.length < maxSave) {
          this.namePanelCoverVisible = true;
          this.filterSaveNameVisible = true;
          // this.filtersService.confirmSelections();
          return true;
        } else {
          window.alert(
            'Only ' +
            maxSave +
            ' filters can be saved. Please delete an existing one by clicking on "My Saved Filters" at the top.'
          );
          return false;
        }
      });
  }

  hideFilterNamePanel() {
    this.filterSaveNameVisible = false;
  }

  hideCover() {
    this.namePanelCoverVisible = false;
    this.loaderVisible = false;
  }
  // Show the cover grey transparency
  showCover() {
    this.namePanelCoverVisible = true;
    this.loaderVisible = true;
  }
  showFilterPanel() {
    this.filterRecallVisible = true;
  }

  hideFilterPanel() {
    this.filterRecallVisible = false;
  }

  async recallSavedFilters() {
    this.hideCover();
    this.filterOptions = await this.filterService.preSelectFilters(
      this.filterOptions
    );
    let selectedOption: SelectedFilterOption  = this.getSelectedOptions(this.filterOptions);
    const regionCode = this.filterOptionService.mapRegionsToCodes(
      selectedOption.Regions ?? []
    );
    await this._countriesService.getCountries(regionCode, this.divDataView);
    forEach(this.filterOptions, async (option, index) => {
      option.optionList = await this.applySaveFilters(index, selectedOption);

      // RefreshedUI - If countries are applied update visibility
      if (option.id === 'countries' && option.selected.length > 0) {
        this.firstLevelFiltersSelected = true;
      }

      // save selections visibility
      if (
        this.saveSelectionsLevel <= option.level + 1 &&
        option.selected.length > 0
      ) {
        this.isSaveSelectionLinkVisible = true;
      } else {
        this.isSaveSelectionLinkVisible = false;
      }
      if (option.isSelectedFilter)
        option.selected = option.optionList.filter(a => option.selected.includes(a.split(' ')[0]));
    });

    //Settting the selected options to the filter options
    // to Restore the selected options when we click Filter Button
    this.filterOptionService.setFilterViewOptions(this.filterOptions);
  }

  showDataLoader(index: number) {
    if (this.filterOptions[index]?.isLoading !== undefined) {
      this.filterOptions[index].isLoading = true;
    }
  }

  hideDataLoader(index: number) {
    if (this.filterOptions[index]?.isLoading !== undefined) {
      this.filterOptions[index].isLoading = false;
    }
  }

  async applySaveFilters(index: number, selectedOption: SelectedFilterOption) {
    try {
      this.showDataLoader(index);
      switch (this.divDataView) {
        case 'Distributor':
          return await this.filterOptionService.applySaveFilterOptionsForDistributor(
            index,
            'Distributor',
            selectedOption
          );
        case 'Contract':
          return await this.filterOptionService.applySaveFilterOptionsForContract(
            index,
            'Contract',
            selectedOption
          );
        case 'QSR':
          return await this.filterOptionService.applySaveFilterOptionsForQSR(
            index,
            'QSR',
            selectedOption
          );
        case 'FRS':
          return await this.filterOptionService.applySaveFilterOptionsForFRS(
            index,
            'FRS',
            selectedOption
          );
        default:
          if (this.filterOptions[index]?.isLoading) {
            this.filterOptions[index].isLoading = false;
          }
          return [];
      }
    } finally {
      this.hideDataLoader(index);
    }
  }

  // Updates to account filter selection when exclude deleted accounts checkbox is toggled
  async onSelectExcludeDeletedAccounts() {
    this.filterRequests.setExcludeDeletedAccounts(this.excludeDeletedAccounts);

    // Get account numbers again based on the new selection if higher level filters are selected
    var getSelectedFilters = this.getSelectedOptions(this.filterOptions);
    const topLevelContractGroupsSelected = Array.isArray(getSelectedFilters.H5) && getSelectedFilters.H5.length > 0;
    const secondLevelContractFiltersSelected = Array.isArray(getSelectedFilters.H7) && getSelectedFilters.H7.length > 0;

    if (topLevelContractGroupsSelected || secondLevelContractFiltersSelected) {
      var index = this.filterOptions.findIndex(
        (option) => option.id === 'customerNumberName' || option.id === 'accts'
      );
      this.filterOptions[index].selected = [];
      this.filterOptions[index].optionList = await this.updateOptionsFor(index);
    }
  }

  private getSelectedOptions(filterOptions: FilterOption[]):SelectedFilterOption {
    this.isAcctNumberVisible = true;
    let selectedOption: SelectedFilterOption;
    switch (this.divDataView) {
      case 'Distributor':
        selectedOption = {
          TopLevelContractGroup:
            filterOptions[DistributorFilterModel.TopLevelContractGroup]
              .selected,
          SecondLevelGroup:
            filterOptions[DistributorFilterModel.SecondLevelContractFilter]
              .selected,
          Accounts: filterOptions[DistributorFilterModel.Accts].selected,
          DatePeriod: filterOptions[DistributorFilterModel.Period].selected,
        };
        return selectedOption;
      case 'Contract':
        selectedOption = {
          Regions:
            filterOptions[
              ContractFilterOptionsModel.Regions
            ].selected,
          Countries:
            filterOptions[ContractFilterOptionsModel.Countries].selected,
          H5: filterOptions[ContractFilterOptionsModel.TopLevelCustomerName]
            .selected,
          H7: filterOptions[
            ContractFilterOptionsModel.SecondLevelContractFilter
          ].selected,
          DatePeriod:
            filterOptions[ContractFilterOptionsModel.DateRange].selected,
          Accounts:
            filterOptions[ContractFilterOptionsModel.CustomerNumberName]
              .selected
        };
        return selectedOption;
      case 'QSR':
        selectedOption = {
          Regions:
            filterOptions[QSRFilterOptionsModel.Regions].selected,
          Countries: filterOptions[QSRFilterOptionsModel.Countries].selected,
          H5: filterOptions[QSRFilterOptionsModel.TopLevelCustomerName]
            .selected,
          H7: filterOptions[QSRFilterOptionsModel.SecondLevelContractFilter]
            .selected,
          DatePeriod: filterOptions[QSRFilterOptionsModel.DateRange].selected,
          Accounts:
            filterOptions[QSRFilterOptionsModel.CustomerNumberName].selected,
        };
        return selectedOption;
        case 'FRS':
          selectedOption = {
            Regions:
              filterOptions[FRSFilterOptionsModel.Regions].selected,
            Countries: filterOptions[FRSFilterOptionsModel.Countries].selected,
            H5: filterOptions[FRSFilterOptionsModel.TopLevelCustomerName]
              .selected,
            H7: filterOptions[FRSFilterOptionsModel.SecondLevelContractFilter]
              .selected,
            DatePeriod: filterOptions[FRSFilterOptionsModel.DateRange].selected,
            Accounts:
              filterOptions[FRSFilterOptionsModel.CustomerNumberName].selected,
          };
          return selectedOption;
      default:
        return {};
    }
  }

  setInitialExcludeDeletedAccountsValue() {
    var division = this.selectedDivisionDataView?.division;
    var filters = this.filters;
    var value = filters?.regions ? filters.excludeDeletedAccounts! : (division == Division.Distributor || division == Division.Pest ? false : true);
    this.filterRequests.setExcludeDeletedAccounts(value);
  }

  getSanitizedFilterId(filterTitle:string): string {
    return 'select-'+ filterTitle.toLowerCase().replace(/\s+/g, '-');
  }

  private invalidatePresentationOptionsOnRegionChange() {
    let presentationType = this.filters?.presentationType;
    let translation = this.filters?.translation;

    if(presentationType) {
      this.filters!.presentationType = ""
    }
    if(translation) {
      this.filters!.translation = ""
    }
  }
}
